package com.essntl.features.price.data.supabase.staticprice

import com.essntl.features.price.domain.model.staticprice.StaticPriceModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class StaticPriceDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    val cost: Int?,
    @SerialName("selling_price")
    val sellingPrice: Int?,
    @SerialName("updated_at")
    val updatedAt: String?,
    @SerialName("created_by")
    val createdBy: String?,
    @SerialName("updated_by")
    val updatedBy: String?,
    @SerialName("markup_id_data")
    val markup: PriceMarkupDto?,
) {
    fun toModel() =
        StaticPriceModel(
            id = id,
            createdAt = createdAt,
            cost = cost,
            sellingPrice = sellingPrice,
            updatedAt = updatedAt,
            createdBy = createdBy,
            updatedBy = updatedBy,
            markup = markup?.toModel(),
        )

    companion object {
        const val COLUMNS_VALUE =
            "*, markup_id_data:markup_id(*)"

        fun getColumns() =
            Columns.raw(COLUMNS_VALUE)
    }
}
